const {Question} = require('./Questions')
const { CreateQuestion } = require('./CreateQuestion')
const { UpdateQuestion } = require('./UpdateQuestion')

export { Question, CreateQuestion, UpdateQuestion }
